<template>
  <div v-for="feedback in feedbacks" :key="feedback.id">
    <div v-if="feedback.type === 'reject'">
      Masqué définitivement depuis le
      {{ dateHelper.shortFormat((feedback.feedbackable as RejectFeedback).rejected_at) }}
    </div>
    <div v-else>
      Masqué pour {{ (feedback.feedbackable as DelayFeedback).days }} jours depuis le
      {{ dateHelper.shortFormat((feedback.feedbackable as DelayFeedback).delayed_at) }}
    </div>
    <div v-if="feedback.feedbackable.reason">
      <Icon name="mdi-message" color="white" :size="12" />
      {{ feedback.feedbackable.reason }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import Icon from "@/core/components/icon/Icon.vue";
import dateHelper from "@/core/helpers/dateHelper";
import {DelayFeedback, Feedback, RejectFeedback} from "@/program/interfaces/Program";

defineProps<{
    feedbacks: Feedback[];
}>();
</script>
